import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {PermissionsPref} from '../constants';

export const permissionsEnabled = () =>
	getPreference(PermissionsPref.ENABLED, true);
